module.exports = __webpack_public_path__ + "assets/images/Galewell_logo-diHQn7m.png";